module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/df119834537bf98c8c02f09b1dc40b63.png";